export default "__VITE_ASSET__BZH5wkF2__"